import React from "react";
import { connect } from "react-redux";
import { Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import RecoverValidationForm from "./form/RecoverValidationForm";
import RecoverConfirmationForm from "./form/RecoverConfirmationForm";
import RecoverCompleted from "./form/RecoverCompleted";
import {
  RECOVER_FASE_VALIDATION,
  RECOVER_FASE_CONFIRMATION,
} from "../../../app/infrastructure/appConstants";

const mapState = (state) => ({
  fase: state.recoverUser.fase,
});

const RecoverPage = ({ fase }) => {
  return (
    <Container className="containerFormRecover">
      {fase === RECOVER_FASE_VALIDATION ? (
        <RecoverValidationForm />
      ) : fase === RECOVER_FASE_CONFIRMATION ? (
        <RecoverConfirmationForm />
      ) : (
        <RecoverCompleted />
      )}
    </Container>
  );
};

RecoverPage.propTypes = {
  fase: PropTypes.number.isRequired,
};

export default connect(mapState, null)(RecoverPage);
